<template>
  <div>
    <!-- <keep-alive include="home"> -->
    <keep-alive :include="['home','classification','mine','recom','shopCard','shopCollection','shopCardHome','couponList','myOrder']">
      <router-view/>
    </keep-alive>
    <!-- <aside-nav v-if="showAsideNav"></aside-nav> -->
  </div>
</template>

<script>
import AsideNav from './components/public/AsideNav'
export default {
  name:'app',
  components: {
    AsideNav
  },
  data(){
    return{
      configInfo: null,
      showAsideNav: false
    }
  },
  created(){
  },
  mounted () {
    this.getCpAppConfig()
  },
  methods:{
    isShowNav () {
      const ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger" && (this.configInfo.cp_uid === '1215' || this.configInfo.cp_uid === '10030')) {
        return true;
      }
      return false
    },
    getCpAppConfig() {
      let host = location.host;
      let domain = host.substr(0,host.indexOf('.'));
      this.$axios({
        method: "POST",
        url: "/get/getCpAppConfig",
        data: {
          domain: domain,
        },
        success: data => {
          if(data.data.status == 'success') {
            this.configInfo = data.data.data
            document.title = data.data.data.app_name
            this.showAsideNav = this.isShowNav()
          }
        }
      });
    },
  },
  watch: {
    'configInfo': {
      handler(a, b) {
        if (a !== undefined && a !== null) {
          // document.title = a.app_name
        }
      },
      deep: true,
      immediate: true
    }
  }
}
</script>
<style>
*{-webkit-appearance: none;}
body { /* IOS禁止微信调整字体大小 */
  -webkit-text-size-adjust: 100% !important;
  text-size-adjust: 100% !important;
  -moz-text-size-adjust: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue